import { Token, TOKEN_NAMES } from "../store/global/TokenEnum";
import { Amount } from "../types/amount";
import * as Sentry from "@sentry/browser";
import { TokenMetadata } from "../store/global/getTokenMetadata";
import { Direction } from "../components/Modal/instance/SelectTokenModal/TokenSelectModal";

export const extractTokenList = (tokens: TokenMetadata): Array<Token> => {
  return Array.from(tokens as Array<Token>);
};
export const transformPricesToBalances = (tokens: TokenMetadata) => {
  return Object.keys(tokens).map(token => {
    return {
      symbol: token as Token,
      balance: Amount.ZERO,
    };
  });
};
export const getPriceForToken = (token?: Token, tokenMetadata?: TokenMetadata) => {
  if (tokenMetadata && token) {
    const tokenEntry = tokenMetadata[token];
    if (tokenEntry) {
      return tokenEntry.priceUsd;
    }
  }
  return Amount.ZERO;
};

export const getNameForToken = (token: Token, tokenMetadata?: TokenMetadata): string => {
  if (tokenMetadata) {
    const name = tokenMetadata[token.toUpperCase() as Token]?.name;
    if (name) {
      return name;
    } else {
      Sentry.captureException(`Could not find a name from metadata for ${token}`);
    }
  }
  Sentry.captureException(`No metadata available. Returning hardcoded name for ${token}`);
  return TOKEN_NAMES[token] ?? "";
};

export const isPricingAvailable = (
  tokensMetadata: TokenMetadata | undefined,
  token: Token,
  direction: Direction
) => {
  const tokenMetadata = tokensMetadata?.[token];
  const side = tokenMetadata?.[direction];
  return (side && tokenMetadata?.priceUsd.value.gt(0)) ?? false;
};
